module.exports = __webpack_public_path__ + "static/media/call_selected.9f2a41ca.svg";